"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.i18n = exports.pageLocale = void 0;
const vue_i18n_1 = require("vue-i18n");
const ja_JP_json_1 = __importDefault(require("@locales/ja-JP.json"));
const en_US_json_1 = __importDefault(require("@locales/en-US.json"));
const zh_CN_json_1 = __importDefault(require("@locales/zh-CN.json"));
const zh_TW_json_1 = __importDefault(require("@locales/zh-TW.json"));
const cookie_1 = require("../common/cookie");
const supported = ['ja-JP', 'en-US', 'zh-CN', 'zh-TW'];
function localeFromBCP47(bcp47) {
    if (supported.includes(bcp47)) {
        return bcp47;
    }
    return 'ja-JP';
}
// window is not declared at all in workers, so `typeof` is required to avoid a ReferenceError
const globalWindow = typeof window !== 'undefined' ? window : undefined;
exports.pageLocale = localeFromBCP47(globalWindow?.__locale || (0, cookie_1.getCookie)("locale") || 'ja-JP');
exports.i18n = (0, vue_i18n_1.createI18n)({
    legacy: false,
    locale: exports.pageLocale,
    fallbackLocale: 'ja-JP',
    messages: { 'ja-JP': ja_JP_json_1.default, 'en-US': en_US_json_1.default, 'zh-CN': zh_CN_json_1.default, 'zh-TW': zh_TW_json_1.default },
});
